import React, {useState} from "react";
// reactstrap components
import {Alert, Button, Col, Container, Input, InputGroupAddon, InputGroupText, Row} from "reactstrap";
import LocalizedStrings from "react-localization";
import {report_strings} from "../../translations/report_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import {resource_strings} from "../../translations/resource_translations";
import {common_strings} from "../../translations/common_translations";
import subscriptionHelpers from "../../helpers/SubscriptionHelper";
import businessHelper from "../../helpers/BusinessHelper";
import dateHelpers from "../../helpers/DateHelper";
import InputGroup from "reactstrap/es/InputGroup";
import {RotateCircleLoading} from "react-loadingg";
import Label from "reactstrap/es/Label";
import {alert_strings} from "../../translations/alert_translations";

let reportStrings = new LocalizedStrings(report_strings);
let commonStrings = new LocalizedStrings(common_strings);
let alertStrings = new LocalizedStrings(alert_strings);
let resourceStrings = new LocalizedStrings(resource_strings);

const SubscriptionHeader = (props) => {

    const [currentSubscription, setCurrentSubscription] = useState(subscriptionHelpers.currentSubscription());
    const [isTeacherSession, setIsTeacherSession] = useState(businessHelper.isTeacherSession());
    const [freeTrialAlreadyUsed, setFreeTrialAlreadyUsed] = useState(businessHelper.subUser().premium_used || false);
    const [isPremium, setIsPremium] = useState(businessHelper.subUser().subscription && businessHelper.subUser().subscription.includes("prem"));
    const [subUser, setSubUser] = useState(businessHelper.subUser());

    function localize() {
        const loc = localeHelpers.currentLocale();
        reportStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        alertStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    localize();

    function expiryDate() {
        if (currentSubscription)
            if (currentSubscription.id === "plan_premium") {
                return resourceStrings.expires + ": " + dateHelpers.formatDate(new Date(subUser.premium_exp_date));
            } else {
                return subUser.subscr_end_w ? resourceStrings.expires + ": " + dateHelpers.formatDate(new Date(subUser.subscr_end_w)) : "";
            }
        else {
            if (subUser.subscription && subUser.subscription.includes("prem") && subUser.premium_exp_date) {
                return resourceStrings.expires + ": " + dateHelpers.formatDate(new Date(subUser.premium_exp_date));
            } else {
                if (subUser.subscription && subUser.subscription.includes("prem")) {
                    return ""
                }
                return resourceStrings.subscriptions.free_plan_expl;
            }
        }
    }

    function hasPermissionToCancel() {
        const isTeacher = businessHelper.isTeacherSession();
        const subscriptionType = subscriptionHelpers.subscriptionPlan();

        if (!isTeacher) {
            return true
        } else {
            return resourceStrings.subscriptions.ent_plan !== subscriptionType
        }
    }

    function hasCancelableSubscription() {
        return currentSubscription && currentSubscription.plan !== "premium_pro"
    }

    function getDiscountValue() {
        switch (props.discountCode) {
            case "OPENFRIEND":
                return "40"
            case "DEENAOPEN":
                return "40"
            case "ANANDA-20":
                return "20"
            case "OPENSTART":
                return "20"
            default:
                return "20"
        }
    }

    return (
        <>
            <div className="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
                 style={{
                     maxHeight: "500px",
                     backgroundImage: "url(" + require("assets/img/theme/stats_back.jpg") + ")",
                     backgroundSize: "cover",
                     backgroundPosition: "center bottom"
                 }}
            >
                {/* Mask */}
                <span className="mask bg-gradient-dark opacity-7"/>
                <Container className="d-flex align-items-center" fluid>
                    <Row style={{width: "100%"}}>
                        <Col lg="8" md="8">
                            <h1 className="display-2 text-white">{subscriptionHelpers.subscriptionPlan()}</h1>
                            <p className="text-white">{resourceStrings.subscriptions.your_current_plan}</p>
                            <small className="text-warning mt-0 mb-4">
                                {expiryDate()}
                            </small>
                            <small className="text-white mt-0 mb-4">
                            </small>
                            {hasCancelableSubscription() && hasPermissionToCancel() &&
                            <Row style={{alignItems: 'flex-end', marginLeft: 16, marginTop: 8}}>
                                <Button
                                    color="secondary"
                                    onClick={e => props.cancelSubscription()}
                                >
                                    {resourceStrings.subscriptions.cancel}
                                </Button>
                            </Row>
                            }
                            {!currentSubscription && !freeTrialAlreadyUsed && !isPremium &&
                            <Row style={{alignItems: 'flex-end', marginLeft: 4, marginTop: 8}}>
                                <Button
                                    color="secondary"
                                    // outline="button"
                                    onClick={e => props.enableFreeTrial()}
                                >
                                    {resourceStrings.subscriptions.enable_free_trial}
                                </Button>
                            </Row>
                            }
                        </Col>
                        {/*{(!currentSubscription || currentSubscription.id === "plan_premium") &&*/}
                        {/*<Col lg="4" className="mt-4" style={{width: "100%"}}>*/}
                        {/*    {!props.applyDiscount &&*/}
                        {/*    <Input*/}
                        {/*        style={{borderRadius: 50, textAlign: "center", maxWidth: 200}}*/}
                        {/*        className="form-control-alternative"*/}
                        {/*        onChange={props.onCodeInput}*/}
                        {/*        // value={this.state.smInput}*/}
                        {/*        id="input-sm"*/}
                        {/*        placeholder={commonStrings.coupon_code}*/}
                        {/*        type="text"*/}
                        {/*    />*/}
                        {/*    }*/}
                        {/*    {props.applyDiscount &&*/}
                        {/*    <Alert color="success">*/}
                        {/*        <strong>{alertStrings.coupon_success}</strong> {alertStrings.formatString(alertStrings.coupon_success_alert, getDiscountValue())}*/}
                        {/*    </Alert>*/}
                        {/*    }*/}
                        {/*</Col>*/}
                        {/*}*/}
                    </Row>
                </Container>
            </div>
        </>
    );
}

export default SubscriptionHeader;
